module.exports = __webpack_public_path__ + "static/media/a.ffe66988.svg";